let map = null;
const url = document.getElementById('getUnitsRoute').value;
const template = document.getElementById('store-card-template');

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function() {
    if (navigator.geolocation) {
        // If geolocation is supported
        getUserLocationCards();
    } else {
        console.log("Geolocation is not supported by this browser.");
        getDefaultCards();
    }

    // Store search
    document.getElementById('searchMapForm').addEventListener('submit', (e) => {
        e.preventDefault();
        getSearchCards();
    });
});

function getUserLocationCards() {
    navigator.geolocation.getCurrentPosition(
        function (position) {
            let latitude = position.coords.latitude;
            let longitude = position.coords.longitude;
            
            console.log("Latitude: " + latitude + ", Longitude: " + longitude);

            fetch(url, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify({ latitude: latitude, longitude: longitude }),
            })
            .then(response => response.text())
            .then(posts => {
                posts = JSON.parse(posts);
                updateCardsAndMap(posts.data);
            })
            .catch(error => console.error('Error:', error));
        },
        function (error) {
            console.error("Error getting location: ", error);
            getDefaultCards();
        }
    );
}


function getDefaultCards() {
    let latitude = 0;
    let longitude = 0;
    fetch(url, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ latitude: latitude, longitude: longitude }),
    })
    .then(response => response.text())
    .then(posts => {
        posts = JSON.parse(posts);
        updateCardsAndMap(posts.data);
    })
    .catch(error => console.error('Error:', error));
}

function getSearchCards() {
    let search = document.getElementById('search').value.toLowerCase();
    fetch(url, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ search: search }),
    })
    .then(response => response.text())
    .then(posts => {
        posts = JSON.parse(posts);
        
        if (posts.data.length === 0) {
            alert('Nenhuma Loja encontrada com a pesquisa realizada.');
        } else {
            updateCardsAndMap(posts.data, true);
        }
    })
    .catch(error => console.error('Error:', error));
}

function updateCardsAndMap(stores, isSearch = false) {
    const cardsContainer = document.getElementById('cards-row');
    cardsContainer.innerHTML = '';

    stores.forEach((store, index) => {
        const card = template.content.cloneNode(true);
        const cardElement = card.querySelector('[storeCard]');

        // Set data attributes for map functionality
        cardElement.setAttribute('data-title', store.title);
        cardElement.setAttribute('data-lat', store.lat);
        cardElement.setAttribute('data-lng', store.lng);
        cardElement.setAttribute('data-address', store.address);
        cardElement.setAttribute('data-link', store.link);

        // Set active class if first item
        if (index === 0) {
            cardElement.querySelector('.item').classList.add('active');
        }

        // Fill in the content
        card.querySelector('[data-store-title]').textContent = store.title;
        card.querySelector('[data-store-address]').textContent = store.address;

        // Handle phone
        if (store.phone) {
            const phoneContainer = card.querySelector('.phone-container');
            const phoneLink = card.querySelector('[data-store-phone]');
            phoneContainer.style.display = 'flex';
            phoneLink.href = `tel:${store.phone.replace(/\W/g, '')}`;
            phoneLink.textContent = store.phone;
        }

        // Handle email
        if (store.email) {
            const emailContainer = card.querySelector('.email-container');
            const emailLink = card.querySelector('[data-store-email]');
            emailContainer.style.display = 'flex';
            emailLink.href = `mailto:${store.email}`;
            emailLink.textContent = store.email;
        }

        // Handle WhatsApp
        if (store.wpp) {
            const whatsappContainer = card.querySelector('.whatsapp-container');
            const whatsappLink = card.querySelector('[data-store-whatsapp]');
            whatsappContainer.style.display = 'flex';
            whatsappLink.href = `https://wa.me/${store.wpp.replace(/\W/g, '')}`;
            whatsappLink.textContent = store.wpp;
        }

        // Handle distance
        if (store.distance) {
            const distanceContainer = card.querySelector('.distance-container');
            const distanceText = card.querySelector('[data-store-distance]');
            distanceContainer.style.display = 'flex';
            distanceText.textContent = store.distance;
        }

        // Handle link
        if (store.link) {
            const linkContainer = card.querySelector('.link-container');
            const linkTexts = card.querySelectorAll('[data-store-link]');
            linkContainer.style.display = 'flex';
            linkTexts.forEach(link => {
                link.href = store.link || '#';
            })
        }

        // Add map button click handler
        const mapBtn = card.querySelector('#btn-ir-ao-site');
        mapBtn.addEventListener('click', () => {
            // Remove active class from all cards
            document.querySelectorAll('.item').forEach(item => item.classList.remove('active'));
            // Add active class to clicked card
            cardElement.querySelector('.item').classList.add('active');
            // Center map on store location and open popup
            if (map) {
                map.setView([store.lat, store.lng], 16);
                // Find and open the corresponding marker
                const markers = document.querySelectorAll('.leaflet-marker-icon');
                markers.forEach(marker => {
                    const markerInstance = marker.__marker;
                    if (markerInstance && markerInstance.getLatLng().lat === parseFloat(store.lat) && markerInstance.getLatLng().lng === parseFloat(store.lng)) {
                        markerInstance.openPopup();
                    }
                });
            }
        });

        cardsContainer.appendChild(card);
    });

    // Wait a bit for the DOM to update before generating the map
    setTimeout(() => {
        generateMap(isSearch);
    }, 100);
}

function generateMap(isSearch = false) {
    const mapElement = document.getElementById('mapa');
    if (!mapElement) {
        console.error('Map element not found');
        return;
    }

    if (isSearch && map) {
        map.remove();
        mapElement.innerHTML = "";
    }

    let iconWidthAndHeight = [
        screen.width > 992 ? 59 : 59,
        screen.width > 992 ? 78 : 78,
    ];

    const mapIcon = document.querySelector("#map-icon");
    if (!mapIcon) {
        console.error('Map icon not found');
        return;
    }

    let customIcon = {
        iconUrl: mapIcon.value,
        iconSize: [iconWidthAndHeight[0], iconWidthAndHeight[1]],
        iconAnchor: [iconWidthAndHeight[0] / 2, iconWidthAndHeight[1]], // Center bottom of icon
        popupAnchor: [0, -iconWidthAndHeight[1] - 10], // Position popup above the marker with some padding
        setZIndex: 10,
    }
    let myIcon = L.icon(customIcon);

    const cards = document.querySelectorAll('[storeCard]');

    // Default center coordinates (São Paulo)
    let defaultLatitude = '-23.5635';
    let defaultLongitude = '-46.6543';

    // If we have cards, use the first one's coordinates
    if (cards.length > 0) {
        const firstCard = cards[0];
        if (firstCard) {
            defaultLatitude = firstCard.getAttribute('data-lat');
            defaultLongitude = firstCard.getAttribute('data-lng');
        }
    }

    // Create map centered on first card or default location
    map = L.map('mapa', {
        closePopupOnClick: true
    }).setView([defaultLatitude, defaultLongitude], 14);

    // Add tile layer
    let layer = new L.TileLayer(
        "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 16
        }
    );

    map.addLayer(layer);

    // Add markers for each store
    if (cards.length > 0) {
        cards.forEach((card) => {
            let latitude = card.getAttribute('data-lat');
            let longitude = card.getAttribute('data-lng');
            let title = card.getAttribute('data-title');
            let address = card.getAttribute('data-address');

            let iconOptions = {
                title: title,
                draggable: false,
                icon: myIcon,
            }

            // Create marker
            let marker = new L.Marker([latitude, longitude], iconOptions);
            marker.addTo(map);

            // Store marker instance on DOM element for later reference
            marker._icon.__marker = marker;

            // Bind popup
            marker.bindPopup(
                `
                    <h4>${title}</h4>
                    <ul>
                        <li>
                            <a href="https://www.google.com/maps?q=${encodeURIComponent(address)}" target="_blank">
                                ${address}
                            </a>
                        </li>
                    </ul>

                `, {
                autoClose: true,
                closeButton: false,
                closeOnClick: false,
                offset: [185, -160], // Adjust popup position relative to marker
                className: 'custom-popup' // Add custom class for styling if needed
            });

            // Open popup for first marker
            if (defaultLatitude === latitude) {
                marker.openPopup();
            }
        });
    }

    map.setZoom(10);
}
